<template>
    <div class="card m-0">
        <div class="card-content">
            <div class="card-body">
                <ValidationObserver v-slot="{ handleSubmit }">
                    <form class="form form-horizontal"
                          @submit.prevent="handleSubmit(submitForm)">
                        <div class="form-body">
                            <div class="row">
                                <div class="col-12" v-if="errorMessage.trim() !== ''">
                                    <div class="form-group row">
                                        <div class="col-12">
                                            <div class="alert alert-danger">
                                                {{ errorMessage.trim() }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group row">
                                        <div class="col-md-3">
                                            <label for="tariffName">Nomlanishi тарифа <span class="text-danger">*</span></label>
                                        </div>
                                        <div class="col-md-9">
                                            <ValidationProvider name="Tarif nomi" rules="required" v-slot="{ errors }">
                                                <div class="position-relative has-icon-left">
                                                    <input type="text" id="tariffName" class="form-control" placeholder="Tarif nomi"
                                                               v-model.trim="tariff.tariffName">
                                                </div>
                                                <span class="text-danger" v-if="errors.length > 0">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group row">
                                        <div class="col-md-3">
                                            <label for="summa">Narxi <span class="text-danger">*</span></label>
                                        </div>
                                        <div class="col-md-9">
                                            <ValidationProvider name="summa" rules="required" v-slot="{ errors }">
                                                <div class="position-relative has-icon-left">
                                                    <input type="number" id="summa" class="form-control" placeholder="Narxi"
                                                           v-model="tariff.summa">
                                                </div>
                                                <span class="text-danger" v-if="errors.length > 0">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group row">
                                        <div class="col-md-3">
                                            <label for="deviceCount">Qurilmalar soni <span class="text-danger">*</span></label>
                                        </div>
                                        <div class="col-md-9">
                                            <ValidationProvider name="Qurilmalar soni" rules="required" v-slot="{ errors }">
                                                <div class="position-relative has-icon-left">
                                                    <input type="number" id="deviceCount" class="form-control" placeholder="Qurilmalar soni"
                                                           v-model="tariff.deviceCount">
                                                </div>
                                                <span class="text-danger" v-if="errors.length > 0">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group row">
                                        <div class="col-md-3">
                                            <label for="comment">Komment</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="position-relative has-icon-left">
                                            <textarea type="text" id="comment" class="form-control" placeholder="Komment"
                                                      v-model.trim="tariff.comment" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group row mb-0">
                                        <div class="col-12 d-flex justify-content-end">
                                            <button type="submit" class="btn btn-info waves-effect waves-light mr-1"
                                                    :disabled="loading"
                                                    v-if="successMessage === ''">
                                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                                      v-if="loading"/>
                                                {{ update ? 'Yangilash' : 'Saqlash' }}
                                            </button>
                                            <button type="button" class="btn btn-success mr-1" disabled="disabled"
                                                    v-if="successMessage !== ''">
                                                <i class="feather icon-check" />
                                                {{ successMessage }}
                                            </button>
                                            <button type="button" class="btn btn-outline-info waves-effect waves-light"
                                                    v-if="successMessage === ''"
                                                    :disabled="loading"
                                                    @click="closeModal">
                                                Bekor qilish
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>
    import { ValidationProvider, extend, ValidationObserver} from 'vee-validate';
    import { required } from 'vee-validate/dist/rules';

    extend('required', {
        ...required,
        message: 'Kiriting {_field_}'
    });

    export default {

        name: "TariffForm",
        props: {
            tariff: Object,
            show: Boolean,
            getTariffs: Function
        },
        data() {
            return {
                errorMessage: '',
                loading: false,
                successMessage: ''
            }
        },
        components: {
            ValidationObserver,
            ValidationProvider
        },
        methods: {
            submitForm() {
                this.loading = true;
                this.update ? this.updateTariff() : this.storeTariff();
            },
            storeTariff() {
                this.$api.post('admin/Tariff/TariffInsert', this.tariffFormData())
                    .then(res => {
                        if (!res.error) {
                            this.succMessage('Сохранено');
                        }
                        else {
                            this.errMessage(res.error);
                        }
                    })
                    .catch(err => {
                        this.errMessage('Ошибка');
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            updateTariff() {
                this.$api.put('admin/Tariff/TariffEdit', this.tariffFormData())
                    .then(res => {
                        if (!res.error) {
                            this.succMessage('Обновлено');
                        }
                        else {
                            this.errMessage(res.error);
                        }
                    })
                    .catch(err => {
                        this.errMessage('Ошибка');
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            tariffFormData() {
                let form = new FormData();
                for (let prop in this.tariff)
                    form.append(prop, this.tariff[prop]);
                return form;
            },
            errMessage(errorMessage) {
                this.errorMessage = errorMessage;
                setTimeout(() => {
                    this.errorMessage = '';
                }, 5000);
            },
            succMessage(successMessage) {
                this.successMessage = successMessage;
                setTimeout(() => {
                    this.closeModal();
                    this.$emit('saved');
                }, 1000);
            }
        },
        watch: {},
        computed: {
            update() {
                return this.tariff.id !== 0;
            }
        },

    }
</script>

<style scoped>

</style>